import { fallbackCountryUrlHash } from 'Modals/CreateReturnLabelModal/CreateReturnLabelModal.constants'

import type { getEmployee_employee_organisation } from 'Constants/graphql/queries/employee/__generated__/getEmployee'
import type { getOrganisation_organisation } from 'Constants/graphql/queries/organisation/__generated__/getOrganisation'

const replaceUrlPlaceholders = (
  url: string,
  orgId: string,
  returnCaseId: string,
  serialNumber: string,
  imei: string,
) =>
  url
    .replaceAll('{{ORGANISATION_ID}}', orgId)
    .replaceAll('{{RETURN_CASE_ID}}', returnCaseId)
    .replaceAll('{{SERIAL_NUMBER}}', serialNumber)
    .replaceAll('{{IMEI}}', imei)

export const getReturnLabelURL = (
  orgId: string | undefined,
  returnCaseId: string,
  country: string | undefined,
  serialNumber: string | null | undefined,
  imei: string | null | undefined,
  fulfillmentProviderMapping:
    | getEmployee_employee_organisation['fulfillmentProviderMapping']
    | getOrganisation_organisation['fulfillmentProviderMapping'],
) => {
  if (!orgId || !country) {
    return undefined
  }

  const fulfillmentProviderUrl = fulfillmentProviderMapping?.find(
    fulfillmentProviderData => fulfillmentProviderData.country === country,
  )?.fullUrl

  if (fulfillmentProviderUrl) {
    return replaceUrlPlaceholders(
      fulfillmentProviderUrl,
      orgId,
      returnCaseId,
      serialNumber ?? '',
      imei ?? '',
    )
  }

  const fallbackUrlHash = fallbackCountryUrlHash[country]

  if (fallbackUrlHash) {
    return replaceUrlPlaceholders(
      `https://www.dhl.de/retoure/gw/rpcustomerweb/OrderEntry.action?hash=${fallbackUrlHash}&ShipmentReference=rcid{{RETURN_CASE_ID}}_org{{ORGANISATION_ID}}`,
      orgId,
      returnCaseId,
      serialNumber ?? '',
      imei ?? '',
    )
  }

  return undefined
}
